import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: '_.name_field.title',
        defaultMessage: 'Title'
    },
    firstName: {
        id: '_.name_field.first_name',
        defaultMessage: 'First name'
    },
    lastName: {
        id: '_.name_field.last_name',
        defaultMessage: 'Last name'
    }
});
